import R from 'ramda';
import { Observable } from 'rxjs';
import { getProject, getOrganization } from 'application/applicationReducer';

const getObject = key => {
  try {
    const serialized = localStorage.getItem(key);

    if (R.isNil(serialized)) {
      return null;
    } else {
      return JSON.parse(serialized);
    }
  } catch (error) {
    console.log('Error loading state from localStorage: %O', error);
    return null;
  }
};

const putObject = (key, object) => {
  try {
    const serialized = JSON.stringify(object);
    localStorage.setItem(key, serialized);
  } catch (error) {
    console.log('Error saving state to localStorage: %O', error);
  }
};

const removeObject = key => {
  try {
    localStorage.removeItem(key);
  } catch (error) {
    console.log('Error removing object from localStorage: %O', error);
  }
};

export const fetchFromLocalStorage = key =>
  Observable.of(key).map(getObject).map(obj => (R.isNil(obj) ? {} : obj));

export const saveToLocalStorage = (key, data) =>
  Observable.of({ key, data }).do(({ key, data }) => putObject(key, data));

export const removeObjectFromLocalStorage = key =>
  Observable.of({ key }).do(({ key }) => removeObject(key));

export const createKey = (applicationState, step) =>
  `${getProject(applicationState).projectKey}-${getOrganization(
    applicationState,
  ).alias}-${step}`;



// WEBPACK FOOTER //
// ./src/common/localStorageHelpers.js